import { render, staticRenderFns } from "./MixersTable.vue?vue&type=template&id=2ede4243&lang=pug&"
import script from "./MixersTable.vue?vue&type=script&lang=js&"
export * from "./MixersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports